import Vue from "vue";
import Vuex from "vuex";
import MD5Encrypt from "js-md5";
import { Message } from "element-ui";
import VueCookie from "vue-cookie";
import axios from "axios";
// import moment from "moment"; //时间控件
import moment from "moment-timezone";
moment.locale("en");

//vue-i18n
import { i18n } from "../common/lang/vue-i18n";

import util from "../common/util";

// import { GETINGOT_API } from "@/api/api";
import { post, get, ExportOrderReport } from "@/api/axiosConfig";
const $get = get;
const $post = post;
const CardLang = VueCookie.get("CardLang") || "en";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    test: false, //测试用涉及用户、cookie
    loading: false,
    lang: CardLang, //多语言 - 当前语言类型
    Middleware: process.env.VUE_APP_MIDDLEWARE == 'forward' ? true : false /*****接口是否使用中间件【默认true】,true:中间件，false：接口或本地接口*****/,
    UserApi: false, //是否 USER API
    MinusOne: 0, //接口请求的返回结果对result：-1（用户冻结）的统计
    UserToken: "", //登录 注册 忘记密码用
    msgCounts: 0, //消息未读数
    ExportOrderReport: ExportOrderReport,
    walletKey: '&85125d62f592750977abaed12eca5898',// 钱包请求key
    Chat: {
      ADMIN_ID: 426963,//云信管理员【卡淘】['16860','426963']
      GoodType: 1000,//商品
      OrderType: 1001,//订单
      TCGType: 1002,//TCG
      URL: process.env.VUE_CHAT_URL,
      URL2: '../../static/Yunxin/im/main.html'
    },
    webConfig: {
      appId: "CardHobbyService",
      appSecret: "CardHobbyService",
      lag: CardLang.indexOf("zh") > -1 ? "zh" : "en", //en英文 zh 中文
      device: "web",
      version: 1,
      appname: "CardSeller"
    },
    cosConfig: {
      ImagesUrl: "https://images.cardhobby.com/",
      Bucket: "cardhobby-1255531135" /* 必须 */,
      Region: "ap-shanghai" /* 存储桶所在地域，必须字段 */,
      Key: "exampleobject" /* 必须 */,
      Prefix: "", //CardHobby/ /*文件目录*/
      SecretId: "",
      SecretKey: ""
    },
    Exchange: "", //汇率
    ExchangeUser: "", //汇率[根据memberSource]
    UserInfo: {},
    UserDetail: {},
    UserDTL: {},
    ChToken: "", //ChineseToken
    domain:
      process.env.NODE_ENV == "development"
        ? document.location.hostname
        : process.env.VUE_APP_DOMAIN,
    toDay: moment(new Date())
      .startOf("day")
      .format("x"), //当天日期yyyy-MM-dd时间戳
    thumbnail: "?imageView2/2/w/200", //腾讯云展示缩略图
    timeZone: moment()
      .format("Zz")
      .toString()
      .trim()
      .split(":")[0],
    tPST: -15,
    mGuess: moment.tz(moment.tz.guess()).format("z"), //当前时区单位（PST PDT CST...）
    exdays: moment(
      new Date().setTime(new Date().getTime() + 24 * 60 * 60 * 1000 * 3)
    )
      .utc()
      .format(), //3天
    PayType: {
      //支付方式：支付宝 = 0, Paypal = 1, 微信 = 2, 银联 = 3, 银联移动 = 4, Stripe=5
      "0": "支付宝",
      "1": "Paypal",
      "2": "微信",
      "3": "银联",
      "4": "银联移动",
      "5": "Stripe",
      "15": "Digitalway"
    },
    SafeRightStatus: {
      //维权 维权中 SRType
      "0": "未开启",
      "1": "Processing", //维权中
      "2": "Processed", //已完成
      "3": "Retracted" //已撤销
    },
    OfferStatus: {
      //议价 0未回复, 1已成交, 2拒绝, 3拒绝不回复, 4失效
      "0": i18n.t("status.toReply"),
      "1": i18n.t("status.sold"),
      "2": i18n.t("status.rejected"),
      "3": i18n.t("status.replied"),
      "4": i18n.t("status.invalidated")
    },
    OrderStatus: {
      //订单   //待支付1，待发货2，待收货3，待评价4，交易完成5，关闭6
      "1": i18n.t("status.payment"),
      "2": i18n.t("status.toBeShipped"),
      "3": i18n.t("status.shipped"),
      "4": i18n.t("status.feedback"),
      "5": i18n.t("status.completed"),
      "6": i18n.t("status.closed")
    },
    ApplyStatus: {
      //申请下架审核状态
      "-2": "Refused(Can apply again)", // 下架申请已驳回
      "-1": "Refused(No more application)", //下架申请已拒绝
      "0": "Processing", //审核中 （申请已提交）
      "1": "Approved" //已处理 （审核通过同意下架）
    },
    ExpressShipper: [], //快递公司列表
    CardStartTime: "", //录入定时上架时间，用于保存继续录入
    pageIs: "", //当前页面
    pageSource: "" //页面来源，记录前一页地址或类型
  },
  mutations: {
    setLoading(state, data) {
      state.loading = data;
    }
  },
  actions: {
    setLoading: ({ commit }, data) => {
      commit("setLoading", data);
    },
    setPageSource(ctx, data) {
      ctx.state.pageSource = data;
      VueCookie.set("Card_page_source", data);
    },
    checkUserToken(ctx) {
      var USERToken = VueCookie.get("Card_Seller_USERTOKEN");
      if (USERToken) {
        ctx.state.UserToken = USERToken;
      } else {
        ctx.dispatch("getToken");
      }
    },
    checkUser(ctx, data) {
      // console.log("checkUser****", data,'1');
      if (ctx.state.UserInfo.Id) {
        console.log("checkUser-if");
        return true;
      } else {
        console.log("checkUser-else");
        var setSellerType = null;
        if (data && data.isSeller) {
          setSellerType = parseInt(data.isSeller);
        }
        var user = VueCookie.get("cardUser");
        var _user = user ? JSON.parse(user) : {};
        // console.log("user: ", user, _user);
        var userDetail = VueCookie.get("Card_Seller_UserDetail");
        // console.log("userDetail: ", userDetail);
        var USERDTL = VueCookie.get("Card_Seller_USERDTL");
        var _USERDTL = JSON.parse(USERDTL);
        var renew = false; //是否重新获取用户详细
        let domain = ctx.state.domain;
        let expires = ctx.state.exdays;
        if (_user && _user["Id"] && _USERDTL && _USERDTL.AccountId) {
          _user["AccountId"] = _USERDTL.AccountId;
        }
        // console.log("cardUser",_user["AccountId"], setSellerType);
        if (setSellerType == 1) {
          renew = true;
          _user["IsSeller"] = true;
          VueCookie.set("cardUser", JSON.stringify(_user), {
            expires,
            domain
          });
        } else if (setSellerType == 0) {
          renew = true;
          _user["IsSeller"] = false;
          VueCookie.set("cardUser", JSON.stringify(_user), {
            expires,
            domain
          });
        }
        if (user && _user["Id"]) {
          if (_user["IsSeller"]) {
            //是卖家
            ctx.state.ChToken = _user.ChineseToken;
            ctx.state.UserInfo = _user;
            ctx.state.UserDetail = userDetail ? JSON.parse(userDetail) : {};

            if (USERDTL && !renew && _USERDTL.ID == _user.MappingUserId) {
              ctx.state.UserDTL = USERDTL ? _USERDTL : {};
            } else {
              ctx.dispatch("getUserDetail", _user);
            }
            return true;
          } else {
            //非卖家
            // console.log("IsSellerrrr", _user.IsSeller);
            window.location = process.env.VUE_APP_CARD_URL;
          }
        } else {
          if (ctx.state.test) {
            ctx.state.UserInfo = util.Test.User;
            ctx.state.ChineseToken = util.Test.User.ChineseToken;
            VueCookie.set("cardUser", JSON.stringify(util.Test.User));
          }
          return false;
        }
      }
    },
    msgCounts(ctx) {
      $get("NotificationCount")
        .then(res => {
          if (res.result) {
            ctx.state.msgCounts = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    Logout(ctx) {
      VueCookie.delete("Card_page_source");
      //登录后如获取不到用户信息去除以下domain
      let domain = ctx.state.domain;
      VueCookie.delete("cardUser", { domain });
      VueCookie.delete("Card_Seller_UserDetail");
      VueCookie.delete("Card_Seller_USERDTL");
      location.href = "/";
    },
    checkExchange(ctx) {
      if (!ctx.state.Exchange) {
        //USD 汇率
        var exchange = VueCookie.get("CardExchange");
        if (exchange && JSON.parse(exchange).Id != undefined) {
          ctx.state.Exchange = JSON.parse(exchange);
        } else {
          ctx.dispatch("getExchange");
        }
      }
      if (!ctx.state.ExchangeUser && ctx.state.UserInfo.Id) {
        //memberSource 用户汇率
        var exchangeUser = VueCookie.get("CardExchangeUser");
        if (exchangeUser && JSON.parse(exchangeUser).Id != undefined) {
          ctx.state.ExchangeUser = JSON.parse(exchangeUser);
        } else {
          ctx.dispatch("getExchangeRate");
        }
      }
    },
    getUserDetail(ctx, UserInfo) {
      //获取用户详细信息
      axios
        .all([
          $get(
            "MemberDetail",
            `?lag=${ctx.state.webConfig.lag}&token=${UserInfo.ChineseToken}&memberId=${UserInfo.MappingUserId}&operator_id=${UserInfo.MappingUserId}`,
            "UserApi"
          ),
          $get("GetMemberInfo", `?MemberId=${UserInfo.Id}`, "UserApi")
        ])
        .then(
          axios.spread(function (MemberDetail, MemberInfo) {
            // 上面两个请求都完成后，才执行这个回调方法
            //console.log('User', MemberDetail.data);
            if (MemberDetail.result && MemberInfo.Result) {
              let domain = process.env.NODE_ENV == 'development' ? document.location.hostname : process.env.VUE_APP_DOMAIN;
              let expires = ctx.state.exdays;
              let _MemberDetail = MemberDetail.data;
              let VerifyStatus = _MemberDetail.VerifyStatus;
              var user = VueCookie.get("cardUser");
              var _user = user ? JSON.parse(user) : {};
              _user['VerifyStatus'] = VerifyStatus;
              _user['MemberSource'] = _MemberDetail.MemberSource;
              _user["AccountId"] = _MemberDetail.AccountId || "";
              console.log("user: ", _MemberDetail.AccountId);
              VueCookie.set("cardUser", JSON.stringify(_user), {
                expires,
                domain
              });
              ctx.state.UserInfo = _user;
              VueCookie.set(
                "Card_Seller_USERDTL",
                JSON.stringify(MemberDetail.data),
                {
                  expires,
                  domain
                }
              );
              VueCookie.set(
                "Card_Seller_UserDetail",
                JSON.stringify(MemberInfo.Data),
                {
                  expires
                }
              );
              Message({
                showClose: true,
                message: "Login successful",
                type: "success"
              });
              location.href = "/";
            } else {
              Message.error("Login failed");
            }
          })
        );
    },
    getToken(ctx) {
      /* 写死的token */
      let Token = MD5Encrypt(
        '{"appId": "CardHobbyService","appSecret": "CardHobbyService"}'
      );
      ctx.state.UserToken = Token;
      let etime = moment(
        new Date().setTime(new Date().getTime() + 5 * 60 * 60 * 1000)
      )
        .utc()
        .format();
      //res.Data.Expires
      VueCookie.set("Card_Seller_USERTOKEN", Token, {
        expires: etime
      });
      /* api get token */
      // $post("GetTokenAuth", {
      //   UserApi: "UserApi",
      //   appId: ctx.state.webConfig.appId,
      //   appSecret: ctx.state.webConfig.appSecret
      // })
      //   .then(res => {
      //     // console.log("axios-res:", res);
      //     if (res.Result) {
      //       ctx.state.UserToken = res.Data.Token;
      //       let etime = moment(
      //         new Date().setTime(new Date().getTime() + 5 * 60 * 60 * 1000)
      //       )
      //         .utc()
      //         .format();
      //       //res.Data.Expires
      //       VueCookie.set("Card_Seller_USERTOKEN", res.Data.Token, {
      //         expires: etime
      //       });
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },
    getExchange(ctx) {
      $get("GetUSD", "none")
        .then(res => {
          // console.log("axios-res:", res);
          if (res.result) {
            let exchange = res.data;
            let _exchange = {
              // Id: exchange["<ID>k__BackingField"],
              // IsLatest: exchange["<IsLatest>k__BackingField"],
              // u: exchange["<Usd>k__BackingField"],
              // c: exchange["<Additional>k__BackingField"]
              Id: exchange["ID"],
              IsLatest: exchange["IsLatest"],
              u: exchange["Usd"],
              c: exchange["Additional"]
            };
            ctx.state.Exchange = _exchange;
            let domain = ctx.state.domain;
            let etime = moment(
              new Date().setTime(new Date().getTime() + 1 * 60 * 60 * 1000)
            )
              .utc()
              .format();
            VueCookie.set("CardExchange", JSON.stringify(_exchange), {
              expires: etime,
              domain
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getExchangeRate(ctx) {
      //根据memberSource获取汇率
      $get("GetExchangeRate", `?memberSource=${ctx.state.UserDTL.MemberSource}`)
        .then(res => {
          // console.log("axios-res:", res);
          if (res.result) {
            let exchange = res.data;
            let _exchange = {
              Id: exchange["ID"],
              IsLatest: exchange["IsLatest"],
              u: exchange["Usd"],
              c: exchange["Additional"]
            };
            ctx.state.ExchangeUser = _exchange;
            let domain = ctx.state.domain;
            let etime = moment(
              new Date().setTime(new Date().getTime() + 1 * 60 * 60 * 1000)
            )
              .utc()
              .format();
            VueCookie.set("CardExchangeUser", JSON.stringify(_exchange), {
              expires: etime,
              domain
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    scrollTop({ commit }, top = 0) {
      document.getElementById("Main").scrollTop = top;
    }
  },
  getters: {
    CHAT: state => (to) => {
      let char_type = 'new'
      if (char_type == 'old') {
        /* Old Chat Yunxin */
        let url2 = state.Chat.URL2;
        let prams2 = `?account=${state.UserDTL.WyAccId}&pwd=${state.UserDTL.WyToken}`
        prams2 = to ? prams2 + `&toaccount=${to == 'admin' ? state.Chat.ADMIN_ID : to}` : prams2
        return url2 + prams2;
      } else {
        /* New Chat Yunxin */
        let url = state.Chat.URL;
        let prams = `?account=${state.UserDTL.WyAccId}&secret=${state.UserDTL.WyToken}&token=${state.UserToken}&chat=true&lag=en`
        prams = to ? prams + `&to=${to == 'admin' ? state.Chat.ADMIN_ID : to}` : prams
        return url + prams;
      }
    },
    getLoading: state => {
      return state.loading;
    },
    setTitle: state => (data, all) => {
      /* 标题去| */
      var titleVal = "";
      if (data) {
        var _title = data.split("|");
        if (_title.length <= 1) {
          titleVal = _title[0];
        } else {
          _title.map(function (obj, k) {
            if (obj) {
              titleVal += obj + " ";
            }
          });
        }
        titleVal =
          titleVal.length > 35 && !all
            ? titleVal.substring(0, 35) + "..."
            : titleVal;
      }
      return titleVal;
    },
    applyUnload: state => data => {
      /* 申请下架是否需要提交申请 */
      let apply = false; //不需要申请
      let Status = data.Status, //0草稿、1出售中、-2已出售、-1下架
        ByWay = data.ByWay, //买卡方式   1一口价、2竞拍
        Bargain = data.Bargain, //是否接受议价（1允许、0不允许）；
        AuctionCount = data.AuctionCount; //竞拍次数、议价次数
      /*
      出售中的、竞拍卡片，竞拍次数 > 0，需要申请下架
      出售中的、一口价（允许议价），议价次数>0，需要申请下架

      出售中的，竞拍卡片，竞拍次数=0，可直接下架
      出售中的，一口价（允许议价），议价次数=0，可直接下架
      出售中的，一口价（不允许议价），可直接下架
      */
      if (Status == 1) {
        if (ByWay == 1 && Bargain == 1 && AuctionCount > 0) {
          /*需要申请下架*/
          apply = true;
        }
        if (ByWay == 2 && AuctionCount > 0) {
          /*需要申请下架*/
          apply = true;
        }
      }
      // console.log(Status, ByWay, Bargain, AuctionCount, apply);
      return apply;
    },
    canUnload: (state, getters) => (can, time) => {
      if (can) {
        const cTime = getters.cTime2CCT(
          moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
        );
        const endTime = moment(time);
        const diff = endTime.diff(moment(cTime), "minute");
        const durationTime = moment.duration(diff, "minute");
        let hours = durationTime.minutes();
        // console.log(endTime.format("YYYY-MM-DD HH:mm:ss"), hours);
        let LTime = process.env.NODE_ENV === "production" ? 60 * 24 : 60;
        if (hours < LTime) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    priceExchange: (state, getters) => (price, type, exchange) => {
      /* 汇率转换 */
      let result = state.exchange || JSON.parse(VueCookie.get("CardExchange"));
      if (exchange) {
        result = { u: exchange, c: 0 }
      }
      let newPice = 0;
      if (parseFloat(price) > 0) {
        if (type == "USD") {
          /* 转美金 */
          newPice = getters.MathRound(
            parseFloat(price) * (result["u"] + result["c"])
          ); //四舍五入
        } else {
          /* 转人民币 */
          newPice = getters.MathRound(
            parseFloat(price) / (result["u"] + result["c"])
          );
        }
      } else {
        newPice = price;
      }
      // console.log("priceExchange:::", price, type, newPice);
      return parseFloat(newPice);
    },
    MathRound: (state, getters) => (num, decimalPlaces = 2) => {
      var d = decimalPlaces || 0;
      var m = Math.pow(10, d);
      var n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
      var i = Math.floor(n),
        f = n - i;
      var e = 1e-8; // Allow for rounding errors in f
      var r =
        f > 0.5 - e && f < 0.5 + e ? (i % 2 == 0 ? i : i + 1) : Math.round(n);
      return d ? r / m : r;
      // return num.toFixed(decimalPlaces); //Math.round(+num + "e" + decimalPlaces) / Math.pow(10, decimalPlaces); //
    },
    endingTime: (state, getters) => (
      startTime,
      addTime = 24,
      addType = "h",
      endTimeNew
    ) => {
      /* 
        日期倒计时
        years（y）：年 quarters（Q）：季度 months（M）：月 weeks（w）：周 days（d）：日 hours（h）：时
        minutes（m）：分 seconds（s）：秒 milliseconds（ms）：毫秒
        .subtract(8, "h")
      */
      let endTime = endTimeNew
        ? moment(endTimeNew)
        : moment(startTime).add(addTime, addType);
      const cTime = getters.cTime2CCT(
        moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      const diff = endTime.diff(moment(cTime), "seconds");
      const durationTime = moment.duration(diff, "seconds");
      let days = durationTime.days(),
        hours = durationTime.hours(),
        minutes = durationTime.minutes(),
        seconds = durationTime.seconds();
      hours = parseInt(hours) <= 0 ? "00" : hours;
      minutes = parseInt(minutes) <= 0 ? "00" : minutes;
      seconds = parseInt(seconds) <= 0 ? "00" : seconds;

      let res = `${hours}:${minutes}:${seconds}`;
      if (endTimeNew) {
        if (days > 0) {
          res = days + "d " + hours + "h";
        } else if (hours > 0 && days == 0) {
          res = hours + "h " + minutes + "m";
        } else if (minutes > 1 && hours == 0 && days == 0) {
          res = minutes + "m " + seconds + "s";
        } else if (minutes < 1 && seconds != 0 && hours == 0 && days == 0) {
          res = "00m " + seconds + "s";
        } else if (days <= -1 || seconds == 0) {
          return "00:00";
        }
      }
      return res;
    },
    timeCountDown: (state, getters) => val => {
      //秒数倒计时
      var dd = Math.floor(val / 60 / 60 / 24);
      var hh = Math.floor((val / 60 / 60) % 24);
      var mm = Math.floor((val / 60) % 60);
      var ss = Math.floor(val % 60);
      let res = "00:00";
      if (dd > 0) {
        res = dd + "d " + hh + "h";
      } else if (hh > 0 && dd == 0) {
        res = hh + "h " + mm + "m";
      } else if (mm >= 1 && hh == 0 && dd == 0) {
        res = mm + "m " + ss + "s";
      } else if (mm < 1 && ss != 0 && hh == 0 && dd == 0) {
        res = ss + "s";
      } else if (dd <= -1 || ss == 0) {
        return "00:00";
      }
      return res;
    },
    cTime2CCT: (state, getters) => val => {
      /*当前时区->转UTC->转北京时间*/
      // let guess = { PST: "America/Los_Angeles", CCT: "Asia/Shanghai" };
      let CCT = val;
      if (state.timeZone != "+08") {
        CCT = getters.getTime(val, 8, "cmtNull", "YYYY-MM-DD HH:mm:ss");
      }
      return CCT; //time;
    },
    momentFormat: (state, getters) => val => {
      console.log("momentFormat", val);
      return moment(val).format("YYYY-MM-DD HH:mm:ss");
    },
    setUTC: (state, getters) => (val, i = -8, type = "cn") => {
      var date = new Date(val);
      // console.log("setUTC-i:", i,val);
      if (type == "cn") {
        var now = new Date();
        now = moment(now)
          .format("ZZ")
          .substring(0, 3);
        now = Number(now);
        // console.log("setUTC-moment-now:", now, Math.abs(now));
        // console.log("setUTC-now:", now);
        if (now != 8) {
          i = i + now + i;
        }
      }
      var len = date.getTime();
      var offset = date.getTimezoneOffset() * 60000;
      var utcTime = len + offset;
      var newTime = new Date(utcTime + 3600000 * i);
      return newTime;
    },
    // MMM DD, YYYY HH:mm:ss 格式时间写成 MMM DD, YYYY      HH:mm:ss（把时间分成两个部分来换行）
    separatedTime: (state, getters) => (val, timeType) => {
      //时间分割
      return getters.getTime(val, state.lang.indexOf("zh") > -1 ? 8 : -8, "", "", timeType);
    },
    getTime: (state, getters) => (val, i = -8, cmtNull, fmt, timeType) => {
      // console.log(val, i, cmtNull, fmt, timeType);
      //var newTime = getters.setUTC(val, i, type);//转utc根据时差+-
      var newTime = "";
      var time = "";
      var cmt = "";
      var timeDiff = moment().utcOffset(); //当前时区时差 +8 -8 -7....（分钟）
      console.log('timeDifftimeDiff,',timeDiff)
      var diffCST = timeDiff - 8 * 60; //与北京时间的总时差 (当前时差) - 8*60（分钟）
      var diffAbs = Math.abs(diffCST); //总时差绝对值
      switch (i) {
        case -8: //北京时间转其他时间
          // var newTime = moment(val).subtract(15, "h"); //-8
          /*
           * newTime：北京时间 减去 时差绝对值 + 8 （小时）
           */
          if (diffCST < 0) {
            //与北京时间的总时差小于0 减（如：北京时间->美国 北京时间-15）
            newTime = moment(val).subtract(diffAbs, "m");
          } else {
            newTime = moment(val).add(diffAbs, "m");
          }
          fmt = fmt ? fmt : "MMM DD, YYYY HH:mm:ss";
          time = moment(newTime).format(fmt);
          cmt = cmtNull ? "" : ""; //${["PDT", "PST"].indexOf(state.mGuess) > -1? " " + state.mGuess: ""}
          break;
        case 8: //其他时间转北京时间
          if (diffCST < 0) {
            //与北京时间的总时差小于0 减（如：美国->北京时间 美国时间+15(diffCST时差为-15)）
            newTime = moment(val).add(diffAbs, "m");
          } else {
            newTime = moment(val).subtract(diffAbs, "m");
          }
          fmt = fmt ? fmt : "YYYY-MM-DD HH:mm:ss";
          time = moment(newTime).format(fmt);
          cmt = ""; //CCT
          break;
      }
      if (timeType == "cut") {
        let ymd = state.lang.indexOf("zh") > -1 ? "YYYY-MM-DD" : "MMM DD, YYYY"
        let a1 = moment(newTime).format(ymd);
        let a2 = moment(newTime).format("HH:mm:ss");
        return [a1, a2 + cmt];
      } else {
        return time + cmt;
      }
    },
    timeCount: (state, getters) => (date, val, type, state) => {
      /*
      用于时间加、减
      date:时间, 
      val:需加、减的时间差,
      state：add/subtract(加或减), 
      type:加减时间类型(years:y、months:M、days:d,hours:h,minutes:m,seconds:s...)
      */
      var newTime = "";
      if (state == "add") {
        //与北京时间的总时差小于0 减（如：美国->北京时间 美国时间+15(diffCST时差为-15)）
        newTime = moment(date).add(val, type);
      } else {
        newTime = moment(date).subtract(val, type);
      }
      return newTime;
    },
    getDateTime: (state, getters) => (fmt, unix) => {
      /** 
      *  fmt:"yyyy-MM-dd" "yyyy-MM-dd HH:mm:ss"
      *  unix: time date unix
      * **/
      var date = unix ? new Date(unix) : new Date();
      console.log(date)
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    },
    stopBidsDate: (state, getters) => (EffectiveDay, LastOnTime) => {
      /* 根据发布时间和上架天数 计算截标时间 */
      /* timeEnd：截标时间（北京时间）= 上架时间（LastOnTime[北京时间]）+ 上架天数（EffectiveDay）*/
      let timeEnd = moment(LastOnTime).add(EffectiveDay, "d");
      /* utcEndDate:  截标时间（UTC协调世界时） = 北京时间截标时 -8 */
      let utcEndDate = moment(timeEnd).subtract(8, "h");
      // console.log('计算截标时间 - stopBidsDate', EffectiveDay, LastOnTime, timeEnd.format("YYYY-MM-DD HH:mm:ss"));
      let timeDiff = [
        {
          'date': moment(utcEndDate).subtract(5, "h").format("MMM DD, YYYY HH:mm:ss ddd"),//美东 UTC-5
          'zhName': "美东",
          'enName': 'EST'
        }, {
          'date': moment(utcEndDate).subtract(8, "h").format("MMM DD, YYYY HH:mm:ss ddd"),//美西 UTC-8
          'zhName': "美西",
          'enName': 'PST'
        }, {
          'date': moment(timeEnd).format("MMM DD, YYYY HH:mm:ss ddd"),//中国 UTC+8（即timeEnd：截标时间（北京时间））
          'zhName': "中国",
          'enName': 'China'
        },
        {
          'date': moment(utcEndDate).format("MMM DD, YYYY HH:mm:ss ddd"),//英国 UTC+0 .add(1, "h")
          'zhName': "英国",
          'enName': 'England'
        },
        , {
          'date': moment(utcEndDate).add(9, "h").format("MMM DD, YYYY HH:mm:ss ddd"),//日本  UTC+9
          'zhName': "日本",
          'enName': 'Japan'
        },
      ];
      // console.log('timeDiff', timeDiff)
      return timeDiff
    },
    thousandAndDecimal: (state, getters) => (num, type) => {
      /*千分位*/
      var val = "";
      if (num) {
        val = parseFloat(num)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      }
      return val;
    },
    setValWithLang: (state, getters) => (item, obj = []) => {
      //根据语言类型切换语言显示
      /*
        item={"chName":"张三","enName":"hello","hkName":"張三"}
        obj=["enName","hkName","chName"]//**需固定顺序 英，繁，简...
        return item[obj[0]]  //hello
       */
      let key = 0;
      switch (state.lang) {
        case "zh-tw"://繁中
          key = 1;
          break;
        case "zh_simplified"://简中
          key = 2;
          break;
        default:
          //en
          key = 0;
          break;
      }
      // console.log(item[obj[key]]);
      return item[obj[key]];
    },
    isEmoji: (state, getters) => (val, type) => {
      let value = val;
      value = value.replace(
        /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
        ""
      );
      value = value.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, "");
      value = value.replace(/[\uE000-\uF8FF]/g, "");
      if (type === 0) {
        //禁止回车换行
        value = value.replace(/<\/?.+?>/g, "");
        value = value.replace(/[\r\n]/g, "");
      }
      return value;
    },
    numMulti: (state, getters) => (num1, num2)=> {
      var baseNum = 0;
      console.log(num1, num2)
      try {
        baseNum += num1.toString().split(".")[1].length;
      } catch (e) {}
      try {
        baseNum += num2.toString().split(".")[1].length;
      } catch (e) {}
      return (
        (Number(num1.toString().replace(".", "")) *
          Number(num2.toString().replace(".", ""))) /
        Math.pow(10, baseNum)
      );
    }
  },

  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js